// TODO: continua até acabar com as minutas ai deleta essa classe?
export const configurationCKEditor_OLD = {
    width: '100%',
    skin: 'moonocolor',
    enableTabKeyTools: true,
    tabSpaces: 4,
    entities_latin: true,
    toolbar: [
        // {
        //     name: 'document',
        //     items: ['Print']
        // },
        {
            name: 'clipboard',
            items: ['Undo', 'Redo']
        }, {
            name: 'styles',
            items: ['GeStyles', 'Font', 'FontSize']
        }, {
            name: 'basicstyles',
            items: [
                'Bold',
                'Italic',
                'Underline',
                'Strike',
                'RemoveFormat',
                'CopyFormatting'
            ]
        }, {
            name: 'colors',
            items: ['TextColor', 'BGColor']
        }, {
            name: 'align',
            items: ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
        }, {
            name: 'links',
            items: ['Link', 'Unlink']
        }, {
            name: 'paragraph',
            items: [
                'NumberedList',
                'BulletedList',
                '-',
                '-',
                'Blockquote'
            ]
        }, {
            name: 'tools',
            items: ['Maximize', 'lineheight', 'Zoom']
        }
    ],
    customConfig: '',
    disallowedContent: 'img{width,height,float}; a',
    extraAllowedContent: 'img[width,height,align]; span',
    extraPlugins: 'dialog,justify,tableresize,print,font,clipboard,pastefromword,colorbutton,floatpanel,panelbutton,entities,tab,lineheight,svtopico,gestylescombo,zoom,blockimagepaste',
    removePlugins: 'magicline,elementspath,tableresize,tabletools,tableselection,table,uploadfile,uploadimage,uploadwidget',
    height: window.innerHeight - 250,
    // Caminhos absolutos: o CKEditor resolve caminho relativo contra a URL da rota,
    // e ambos os arquivos são servidos a partir da raiz.
    contentsCss: [
        '/ckeditor/contents.css',
        '/mystyles.css'
    ],
    bodyClass: 'document-editor',
    format_tags: 'p;h1;h2;h3;pre',
    removeDialogTabs: 'image:advanced;link:advanced',
    stylesSet: [
        {
            name: 'Corpo', element: 'p', styles: {
                'mso-style-name': ' Corpo',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'black'
            }
        },
        {
            name: 'Identificação', element: 'p', styles:
            {
                'mso-style-name': 'Identificação',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'black'
            }
        },
        {
            name: 'Ementa', element: 'p', styles: {
                'mso-style-name': 'Ementa',
                'margin-top': '0cm',
                'margin-right': '0cm',
                'margin-bottom': '0cm',
                'margin-left': '8.0cm',
                'text-align': 'justify',
                'line-height': 'normal',
                'text-justify': 'inter-ideograph',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'olive'
            }
        },
        {
            name: 'Autoridade', element: 'p', styles: {
                'mso-style-name': 'Autoridade',
                'margin-top': '0cm',
                'margin-right': '93.55pt',
                'margin-bottom': '0cm',
                'margin-left': '93.55pt',
                'text-align': 'center',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'black',
                'text-transform': 'uppercase',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Função', element: 'p', styles: {
                'mso-style-name': 'Função',
                'margin-top': '0cm',
                'margin-right': '93.55pt',
                'margin-bottom': '0cm',
                'margin-left': '93.55pt',
                'text-align': 'center',
                'line-height': '150%',
                'text-autospace': 'none',
                'font-size': '10.0pt',
                'font-family': 'Courier',
                'color': 'black',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Num.Processo', element: 'p', styles: {
                'mso-style-name': 'Num.Processo',
                'margin-top': '8.5pt',
                'margin-right': '0cm',
                'margin-bottom': '0cm',
                'margin-left': '0cm',
                'text-align': 'right',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'red',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Transcrição', element: 'p', styles: {
                'mso-style-name': 'Transcrição',
                'margin-top': '0cm',
                'margin-right': '0cm',
                'margin-bottom': '0cm',
                'margin-left': '127.55pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '1.0cm',
                'line-height': '18pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Times New Roman,serif',
                'color': 'black'
            }
        },
        {
            name: 'Transcrição 2', element: 'p', styles: {
                'mso-style-name': 'Transcrição 2',
                'margin-top': '0cm',
                'margin-right': '0cm',
                'margin-bottom': '0cm',
                'margin-left': '184.3pt',
                'line-height': 'normal',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '1.0cm',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Times New Roman,serif',
                'color': 'black'
            }
        },
        {
            name: 'Corre Junto', element: 'p', styles: {
                'mso-style-name': 'Corre Junto',
                'margin-top': '8.5pt',
                'margin-right': '0cm',
                'margin-bottom': '0cm',
                'margin-left': '0cm',
                'text-align': 'right',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'red',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Relatório', element: 'p', styles: {
                'mso-style-name': 'Relatório',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'green'
            }
        },
        {
            name: 'Voto', element: 'p', styles: {
                'mso-style-name': 'Voto',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'blue'
            }
        },
        {
            name: 'Isto Posto', element: 'p', styles: {
                'mso-style-name': 'Isto Posto',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'purple'
            }
        },
        {
            name: 'Tema', element: 'p', styles: {
                'mso-style-name': 'Tema',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.55pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'black',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Despacho', element: 'p', styles: {
                'mso-style-name': 'Despacho',
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'center',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': 'Courier',
                'color': 'black',
                'font-weight': 'bold'
            }
        },
        {
            name: 'Data', element: 'p', styles: {
                'mso-style-name': 'Data',
                'mso-style-link': "Data Char",
                'margin': '0cm',
                'margin-bottom': '.0001pt',
                'text-align': 'justify',
                'text-justify': 'inter-ideograph',
                'text-indent': '127.6pt',
                'line-height': '18.0pt',
                'text-autospace': 'none',
                'font-size': '12.0pt',
                'font-family': "Courier",
                'color': 'fuchsia'

            }
        }
    ]
};

//estilos usados dentro do tst 'fora do padrão'
export const getClassePorEstilosDiferentes = {
    'position: relative; margin-left: 0.98in;text-indent: 0in;margin-top: 0.08in;line-height: 100%;': 'transcricao',
    'text-align: justify;position: relative; text-indent: 1.77in;margin-top: 0in;margin-bottom: 0in;line-height: 150%;':'corpo',
    'text-align: justify;position: relative; text-indent: 1.77in;border-color: #FFFFFF; border-style:solid; border-width:1px;background-color: #FFFFFF;margin-top: 0in;margin-bottom: 0in;line-height: 150%;' : 'corpo',
    'text-align: justify;position: relative; margin-left: 1.77in;text-indent: 0.39in;border-color: #FFFFFF; border-style:solid; border-width:1px;background-color: #FFFFFF;margin-top: 0in;margin-bottom: 0in;': 'transcrio'
}

//estilos no padrão do tst
export const estilosCKEditor = {
    'corpo': 'mso-style-name: Corpo;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;',
    'identificao': 'mso-style-name: Identificação;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black',
    'partes': 'mso-style-name: Identificação;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black',
    'identificacao': 'mso-style-name: Identificação;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black',
    'ementa': 'mso-style-name: Ementa;line-height:normal; margin-top: 0cm;margin-right: 0cm;margin-bottom: 0cm;margin-left: 8.0cm;text-align: justify;text-justify: inter-ideograph;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: olive',
    'autoridade': 'mso-style-name: Autoridade;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;text-transform: uppercase;font-weight: bold',
    'funo': 'mso-style-name: Função;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 150%;text-autospace: none;font-size: 10.0pt;font-family: Courier;color: black;font-weight: bold',
    'ministro': 'mso-style-name: Função;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 150%;text-autospace: none;font-size: 10.0pt;font-family: Courier;color: black;font-weight: bold',
    'funcao': 'mso-style-name: Função;margin-top: 0cm;margin-right: 93.55pt;margin-bottom: 0cm;margin-left: 93.55pt;text-align: center;line-height: 150%;text-autospace: none;font-size: 10.0pt;font-family: Courier;color: black;font-weight: bold',
    'num.processo': 'mso-style-name: Num.Processo;margin-top: 8.5pt;margin-right: 0cm;margin-bottom: 0cm;margin-left: 0cm;text-align: right;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: red;font-weight: bold',
    'numprocesso': 'mso-style-name: Num.Processo;margin-top: 8.5pt;margin-right: 0cm;margin-bottom: 0cm;margin-left: 0cm;text-align: right;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: red;font-weight: bold',
    'transcrio': 'mso-style-name: Transcrição;line-height:18.0pt;margin-top: 0cm;margin-right: 0cm;margin-bottom: 0cm;margin-left: 127.55pt;text-align: justify;text-justify: inter-ideograph;text-indent: 1.0cm;text-autospace: none;font-size: 12.0pt;font-family: Times New Roman,serif;color: black',
    'transcrio2': 'mso-style-name: Transcrição 2;line-height:normal;margin-top: 0cm;margin-right: 0cm;margin-bottom: 0cm;margin-left: 184.3pt;text-align: justify;text-justify: inter-ideograph;text-indent: 1.0cm;text-autospace: none;font-size: 12.0pt;font-family: Times New Roman,serif;color: black',
    'transcricao': 'mso-style-name: Transcrição;line-height:18.0pt;margin-top: 0cm;margin-right: 0cm;margin-bottom: 0cm;margin-left: 127.55pt;text-align: justify;text-justify: inter-ideograph;text-indent: 1.0cm;text-autospace: none;font-size: 12.0pt;font-family: Times New Roman,serif;color: black',
    'transcricao2': 'mso-style-name: Transcrição 2;line-height:normal;margin-top: 0cm;margin-right: 0cm;margin-bottom: 0cm;margin-left: 184.3pt;text-align: justify;text-justify: inter-ideograph;text-indent: 1.0cm;text-autospace: none;font-size: 12.0pt;font-family: Times New Roman,serif;color: black',
    'corre junto': 'mso-style-name: Corre Junto;margin-top: 8.5pt;margin-right: 0cm;margin-bottom: 0cm;margin-left: 0cm;text-align: right;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: red;font-weight: bold',
    'relatrio': 'mso-style-name: Relatório;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: green',
    'relatorio': 'mso-style-name: Relatório;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: green',
    'voto': 'mso-style-name: Voto;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: blue',
    'isto posto': 'mso-style-name: Isto Posto;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: purple',
    'istoposto': 'mso-style-name: Isto Posto;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: purple',
    'tema': 'mso-style-name: Tema;margin: 0cm;margin-bottom: .0001pt;text-align: justify;text-justify: inter-ideograph;text-indent: 127.55pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;font-weight: bold',
    'despacho': 'mso-style-name: Despacho;margin: 0cm;margin-bottom: .0001pt;text-align: center;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family: Courier;color: black;font-weight: bold',
    'data': 'mso-style-name: Data; mso-style-link: Data Char; margin: 0cm; margin-bottom: .0001pt; text-align: justify; text-justify: inter-ideograph;text-indent: 127.6pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family:Courier;color: fuchsia;',
    'date': 'mso-style-name: Data; mso-style-link: Data Char; margin: 0cm; margin-bottom: .0001pt; text-align: justify; text-justify: inter-ideograph;text-indent: 127.6pt;line-height: 18.0pt;text-autospace: none;font-size: 12.0pt;font-family:Courier;color: fuchsia;'
};

